import {Router} from '@angular/router';
import {BusinessObjectType} from '../bonding_shared/model/dictionary-ids';
import {LimitService, View} from '../bonding_shared/services';
import {ClaimInitialParams} from '../bonding/claim/components/claim-selectors.component';
import {ClientCompanyViewParams} from '../bonding/client-company/components/client-company-details.component';
import {LimitViewParams} from '../bonding/limit/limit-details.component';

export abstract class AbstractRouterService {
  protected constructor(protected _router: Router, protected limitService: LimitService) {}

  goBack() {
    window.history.back();
  }

  toLimitDetailsByLimitId(limitId: number) {
    this.limitService.getLastLimitRequestByLimitId(limitId).subscribe((req) => this.toLimitDetails(req.id));
  }

  // CLAIM
  toClaimSearch() {
    this._router.navigate(['bon/claim-search']);
  }

  toClaimDetailsNew(params?: ClaimInitialParams) {
    this._router.navigate(['bon/claim-details'], {queryParams: params});
  }

  toClaimDetails(id: number) {
    this._router.navigate(['bon/claim-details', id]);
  }

  // Business Object
  goToBusinessObject(relatedToId: number, id: number) {
    switch (relatedToId) {
      case BusinessObjectType.LIMIT_REQUEST:
        this.toLimitDetails(id);
        break;
      case BusinessObjectType.LIMIT:
        this.toLimitDetailsByLimitId(id);
        break;
    }
  }

  abstract toLimitDetails(id: number);

  toClientBondDetailsNewWithBondType(contractVersionId: number, bondType: number) {
    this._router.navigate(['bon/clientbond-details', 0, contractVersionId, bondType]);
  }
  toBondDetailsNewWithBondType(clientId: number, contractId: number, bondTypeId: number) {
    this._router.navigate(['bon/bond-details', 0, clientId, contractId, bondTypeId]);
  }

  toNewPolicyInquiryDetails(typeId: number) {
    this._router.navigate(['bon/new-inquiry/', typeId]);
  }

  toClientCompanyDetailsWithParams(params: ClientCompanyViewParams) {
    this.toViewWithParams('client-company-details', params);
  }

  toViewWithParams(viewName: string, params: any) {
    this._router.navigate(['bon/' + viewName], {queryParams: params});
  }

  toLimitDetailsWithParams(params: LimitViewParams) {
    this._router.navigate(['bon/limit-details'], {
      queryParams: params,
    });
  }

  toCustomView(viewId: number, readFromCache: boolean, returnObjectId: number, newObjId: number) {
    const view = View.get(viewId);
    if (view.navigator) {
      view.navigator(this, returnObjectId, newObjId);
    } else if (returnObjectId) {
      this._router.navigate(['bon/' + View.get(viewId).name, returnObjectId]);
    } else {
      this._router.navigate(['bon/' + View.get(viewId).name, readFromCache]);
    }
  }

  navigate(componentSelector: string, id: number, params?: any) {
    console.log('navigate: ' + componentSelector + '/' + id, params);
    if (id) {
      this._router.navigate(['bon/' + componentSelector, id]);
    } else {
      this._router.navigate(
        ['bon/' + componentSelector],
        params
          ? {
              queryParams: params,
            }
          : undefined
      );
    }
  }
}
